import React from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import DcFlink from 'apps/auth/components/send/multiScreen/dcSources/DcFlink';
import { PAYMENT_FLINKS } from 'apps/auth/constants/Constants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const Flinks = ({ isSortedPaymentMethods, flinks, clickHandler, badge, actionBanner }) => {
    const { linkedFlinkAccounts, flinkAddNew } = usePageMessages();
    const showFlink = Array.isArray(flinks) && flinks.length > 0;

    if (showFlink) {
        return (
            <>
                {!isSortedPaymentMethods && (
                    <>
                        <Separator marginBottom="48px" />
                        <Text variant="div" size="subheader" color="secondary" indent="adaptive-16-24">
                            {linkedFlinkAccounts}
                        </Text>
                        <Panel
                            onClick={(e) => {
                                clickHandler(e, PAYMENT_FLINKS);
                            }}
                            negativeMargin
                            isHoverable
                        >
                            <DiskBadgeWrapper>
                                <DiskBadge variant="transparent" iconName="plus" />
                            </DiskBadgeWrapper>
                            {flinkAddNew}
                        </Panel>
                    </>
                )}
                {flinks.map((source) => {
                    return <DcFlink source={source} clickHandler={clickHandler} key={source.code} badge={badge} actionBanner={actionBanner} />;
                })}
            </>
        );
    } else {
        return null;
    }
};

Flinks.propTypes = {
    clickHandler: PropTypes.func,
    isSortedPaymentMethods: PropTypes.bool,
    badge: PropTypes.string,
    actionBanner: PropTypes.string,
    flinks: PropTypes.array,
};
export default Flinks;
